import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

// Get user transactions
export const getUserTransactions = async (userId, params = {}) => {
  try {
    const response = await axiosInstance.get(API_ENDPOINTS.GET_USER_TRANSACTIONS(userId), {
      params: params
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Real monthly subscriptions of the donor (subscriptions rows, not transactions)
export const getUserSubscriptions = async (userId) => {
  try {
    return await axiosInstance.get(`/payment/subscription/list/${userId}`);
  } catch (error) {
    throw error;
  }
};

// Cancel subscription — reason is required by the cancel modal, comment optional
export const cancelSubscription = async (subscriptionId, reason, comment) => {
  try {
    const response = await axiosInstance.post(API_ENDPOINTS.CANCEL_SUBSCRIPTION, {
      subscriptionId,
      reason,
      ...(comment && { comment }),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Fixed reason list for the cancel modal dropdown (single source of truth on the backend)
export const getCancellationReasons = async () => {
  try {
    return await axiosInstance.get("/payment/subscription/cancellation-reasons");
  } catch (error) {
    throw error;
  }
};

